<template>
    <div>
        <div style="width:100%;padding:5px;">
            <span class="btn btn-default" @click="reloadItems">Refresh</span>
        </div>

        <paged-loading :is-loading="loadingImg" @pagechange="onPageChange" :paging-info="pagingInfo">
                <div>
                        <div class="col-xs-12" v-for="item in items" style="margin-top:6px;border:2px solid #808080;padding-bottom:16px;">

                                <div>
                                    <div>
                                        <span style="font-weight:bold;"> orderNum: {{item.id}} </span>
                                        <span style="color:gray;"> date: {{item.localCreateDate}} </span>
                                        <span class="label label-info">{{item.stateText}} </span>
                                    </div>

                                    <div>
                                        <div class="row" style="border-bottom:1px solid gray;font-weight:bold;">
                                            <div class="col-xs-8">
                                               <span>Item Info</span>
                                            </div>
                                            <div class="col-xs-2"> Price </div>
                                            <div class="col-xs-2">Quantity </div>
                                        </div>
                                        <div v-for="(orderItem,index) in item.items" class="act-order-item row" :order-id="orderItem.id" style="border-bottom:1px solid gray;">
                                            <div class="col-xs-8">
                                                <div class="col-xs-12">
                                                    <span style="font-weight:bold;">{{index+1}}.</span>
                                                    <span>{{orderItem.title}}</span>
                                                </div>
                                                <div class="col-xs-12">
                                                    <span v-for="pc in orderItem.propCats">
                                                        {{pc.parent.name}}:{{pc.child.name}}
                                                    </span>
                                                </div>
                                            </div>
                                            <div class="col-xs-2">{{orderItem.price}} </div>
                                            <div class="col-xs-2">x {{orderItem.quant}} </div>
                                        </div>

                                    </div>

                                </div>
                           
                        </div>
                    
                </div>
        </paged-loading>
    </div>
</template>
<script>
    import pagedLoading from '../components/base/PagedLoading.vue';
    import queryString from '../utl/queryString';
    import modal from '../components/base/Modal.vue';
    import apis from '../api/extApi.js';

    export default {
        components: {
            pagedLoading: pagedLoading,
            modal: modal
        },
        props: ["shopUserId"],
        data: function () {
            return {
                apiClient: apis.api,
                pagingInfo: { page: 1, pageSize: 40, count: 0},
                loadingImg: false,
                items: [],
                selectedOrder: null,
                loadedQuery: null
            };
        },
        computed: {
            lang: function () {
                return this.$store.getters.lang;
            }
        },
        methods: {
            reloadItems: function () {
                this.loadItems(this.getQueryString());
            },
            getRoutePage: function () {
                var rPage = this.$route.query.page;
                if (typeof rPage === "undefined") {
                    rPage = 1;
                };
                return rPage;
            },
            onPageChange: function (page) {
                var route = this.$router.currentRoute;
                var query = route.query;
                var newQuery = {};
                for (var n in query) {
                    newQuery[n] = query[n];
                };
                newQuery.page = page;
                var newRoute = {
                    name: "Performance", query: newQuery
                };
                this.$router.push(newRoute);
            },
            getQueryString: function () {
                var queryString = this.$route.fullPath;
                queryString = queryString.split('?')[1];
                if (queryString == null) {
                    queryString = "";
                }
                return queryString;
            },
            loadItems: function (query) {
                this.loadingImg = true;
                this.apiClient.getPerformancePrms(query).done((ret) => {
                    console.log('ret is:',ret);
                    this.loadingImg = false;
                    var filter = ret.filter;
                    this.pagingInfo = { page: filter.page, pageSize: filter.pageSize, count: filter.count };
                    this.items = ret.items;
                    this.loadedQuery = queryString;

                }).fail((ret) => {
                    this.loadingImg = false;
                });
            }
        },
        watch: {
            '$route'(to, from) {
                if (to.name === 'Performance') {
                    this.page = this.getRoutePage();
                    var qstr = this.getQueryString();
                    if (qstr === this.loadedQuery) {
                        return;
                    }
                    this.loadItems(qstr);
                }
            }
        },
        created: function () {
            //this.apiClient.onLoginApi.on(this.reloadItems);
            this.reloadItems();
        },
        destroyed: function () {
            //this.apiClient.onLoginApi.remove(this.reloadItems);
        },
        mounted: function () {

        }
    }
</script>